import React from "react";
import styles from "./Privacy.module.css";

const Privacy = () => {
  return (
    <div className={styles.legalPage}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.pageTitle}>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: August 2026</p>
        
        <div className={styles.legalContent}>
          <p>
            Welcome to the Sanskriti Shubh Aangan society management portal. This Privacy Policy describes how your personal information is collected, used, and shared when you visit or use our platform.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            We collect information from you when you register on our site, fill out a form, or participate in community discussions. The types of personal information collected may include your name, flat number, email address, phone number, and vehicle details.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>
            Any of the information we collect from you may be used in one of the following ways:
          </p>
          <ul>
            <li>To personalize your experience in the community dashboard.</li>
            <li>To improve our platform and society management processes.</li>
            <li>To send periodic emails and SMS regarding society notices, events, and maintenance updates.</li>
            <li>To ensure the safety and security of all residents through our visitor management system.</li>
          </ul>

          <h2>3. Data Protection</h2>
          <p>
            We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information. Your data is encrypted and securely stored.
          </p>

          <h2>4. Sharing of Information</h2>
          <p>
            We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include trusted third parties who assist us in operating our platform, conducting our business, or servicing you, so long as those parties agree to keep this information confidential.
          </p>

          <h2>5. Contact Us</h2>
          <p>
            If there are any questions regarding this privacy policy, you may contact the society management committee via the Contact Us page or at sanskrutishubhaangan@gmail.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
